/**
 * Project Mapping for SEO-friendly URLs.
 * Key is the URL slug, value is the numeric project ID.
 */
export const PROJECT_SLUG_TO_ID = {
    "3-bhk-flats-for-sale-in-srirangam-mitha-rangasthalam": 89,
    "3bhk-flats-for-sale-in-thillainagar/mitha-amethyst": 84,
    "flats-for-sale-in-tennur-mitha-brindhavan": 78,
    "individual-house-for-sale-in-rajiv-gandhi-nagar-mitha-twins": 77,
    "flats-for-sale-vayalur-road-mitha-maanasa": 75,
    "2-bhk-apartments-for-sale-in-raja-colony-cantonment-mitha-premam": 74,
    "mitha-vriksham": 73,
    "2-bhk-flats-for-sale-in-nachikurichi-mitha-haritham": 70
};

/**
 * Reverse mapping for link generation.
 * Key is project ID, value is the URL slug.
 */
export const PROJECT_ID_TO_SLUG = Object.fromEntries(
    Object.entries(PROJECT_SLUG_TO_ID).map(([slug, id]) => [id, slug])
);

/**
 * Static SEO Metadata Overrides for specific projects.
 */
export const SEO_METADATA_OVERRIDES = {
    89: {
        title: "3 BHK Flats for Sale in Srirangam | Mitha Rangasthalam",
        description: "Mitha Rangasthalam offers spacious 3 BHK flats for sale in Srirangam, Ready to use apartments for Sale in srirangam. Combining modern comfort with serene living.",
        ogTitle: "3 BHK Flats for Sale in Srirangam | Mitha Rangasthalam",
        ogDescription: "Mitha Rangasthalam offers spacious 3 BHK flats for sale in Srirangam, Ready to use apartments for Sale in srirangam. Combining modern comfort with serene living.",
        keywords: "flats for sale in srirangam, apartments for sale in srirangam, 3 bhk flats for sale in srirangam"
    },
    84: {
        title: "3 BHK Flats for Sale in Thillai Nagar | Mitha Amethyst",
        description: "Mitha Amethyst offers premium 3 BHK flats in Thillai Nagar, designed with modern amenities for comfortable and elegant living. Reach us for 3 BHK apartments for sale in Thillai Nagar, Trichy.",
        ogTitle: "3 BHK Flats for Sale in Thillai Nagar | Mitha Amethyst",
        ogDescription: "Discover a place where your family grows, laughs, and creates lasting memories. Mitha Amethyst offers beautifully designed 3 BHK flats in Thillai Nagar, blending comfort, elegance, and a location you’ll love to call home.",
        keywords: "flats for sale in Thillai Nagar, apartments for sale in Thillai Nagar, 3 bhk flats for sale in Thillai Nagar"
    },
    78: {
        title: "Flats for Sale in Tennur | Mitha Brindhavan",
        description: "Mitha Brindhavan offers premium flats for sale in Tennur, designed with modern amenities for comfortable urban living",
    },
    77: {
        title: "Villas / Individual House for Sale in Rajiv Gandhi Nagar | Mitha Twins",
        description: "Mitha Twins presents thoughtfully designed villas and individual houses in Rajiv Gandhi Nagar, built for comfort and long-term value.",
    },
    75: {
        title: "2 BHK flats for sale in Vayalur Road | Mitha Maanasa",
        description: "Mitha Maanasa offers well-designed 2 BHK flats for sale on Vayalur Road, featuring modern amenities and comfortable living",
    },
    74: {
        title: "2 BHK Apartments in Raja Colony, Cantonment | Mitha Premam",
        description: "Mitha Premam offers premium residential 2 BHK apartments in Raja Colony, Cantonment, combining modern design with comfortable city living",
    },
    73: {
        title: "Luxury Apartment | Mitha Vriksham ",
        description: "Mitha Vriksham offers premium 3 BHK residential property designed with modern amenities for comfortable and elegant living",
    },
    70: {
        title: "2 BHK Flats in Nachikurichi | Mitha Haritham",
        description: "Mitha Haritham offers spacious 2 BHK Flats in Nachikurichi, blending modern amenities with serene living for your perfect home",
    }
};

/**
 * Get project URL based on ID.
 * Returns either the SEO slug link or the default /project/:id link.
 */
export const getProjectLink = (id) => {
    const slug = PROJECT_ID_TO_SLUG[id];
    return slug ? `/${slug}` : `/project/${id}`;
};
